import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { format } from 'date-fns'

import {
  Paper,
  PaperContent,
  PaperHeadline,
  Divider,
  Link,
  Icon, 
  Text,
  Checkbox,
  Button
} from '../../'
import { OneTimePurchase, SubsPetcademy, SubsVetHelpline, PWIcon } from '../SvgIcons';
import { PUBLIC_URL } from "../../constants";

export class ExistingMembershipPlanCard extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      readMore: false,
    }

    this.readMoreHandler = this.readMoreHandler.bind(this);
  }

  static ProductLogos = Object.freeze({
    petcademy: <SubsPetcademy />,
    vetHelp: <SubsVetHelpline />
  });

  static propTypes = {
    membershipProduct : PropTypes.shape({
      logo: PropTypes.element,
      productName: PropTypes.string,
      productBenefits: PropTypes.array,

      id: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      refProp: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
      ])
    }),
    subscriptionProducts: PropTypes.arrayOf(
      PropTypes.shape({
        logo: PropTypes.element,
        productName: PropTypes.string,
        price: PropTypes.string,
        frequency: PropTypes.string,
        date: PropTypes.string,
        expiryDate: PropTypes.string,
        isCancelled: PropTypes.bool,
        isExpired: PropTypes.bool,
        recId: PropTypes.string,
        id: PropTypes.string,
        className: PropTypes.string,
        style: PropTypes.object,
        refProp: PropTypes.oneOfType([
          PropTypes.func,
          PropTypes.shape({ current: PropTypes.instanceOf(Element) })
        ])
      })
    ),
    combinedMedVetProduct: PropTypes.shape({
      logo: PropTypes.element,
      productName: PropTypes.string,
      price: PropTypes.string,
      frequency: PropTypes.string,
      date: PropTypes.string,
      expiryDate: PropTypes.string,
      isCancelled: PropTypes.bool,
      isExpired: PropTypes.bool,
      autoRenew: PropTypes.bool,
      recId: PropTypes.string,
      id: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      refProp: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
      ])
    }),
    annualProduct: PropTypes.shape({
      logo: PropTypes.element,
      productName: PropTypes.string,
      price: PropTypes.string,
      frequency: PropTypes.string,
      date: PropTypes.string,
      isCancelled: PropTypes.bool,
      expiryDate: PropTypes.string,
      autoRenew: PropTypes.bool,
      recId: PropTypes.string,
      itemId: PropTypes.string,

      id: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      refProp: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
      ])
    }),
    pumpkinWellness: PropTypes.shape({
      logo: PropTypes.element,
      productName: PropTypes.string,
      price: PropTypes.string,
      frequency: PropTypes.string,
      date: PropTypes.string,
      expiryDate: PropTypes.string,
      isCancelled: PropTypes.bool,
      isExpired: PropTypes.bool,
      autoRenew: PropTypes.bool,
      recId: PropTypes.string,
      itemId: PropTypes.string,

      id: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      refProp: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
      ])
    }),
    winbackProduct: PropTypes.shape({
      expiryDate: PropTypes.string,
      offerPrice: PropTypes.string,
    }),
    renewButtonProps: PropTypes.shape({
      active: PropTypes.bool,
      onClick: PropTypes.func,
    }),
    autoRenewLinkProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func,
    }),
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    subscriptionProducts: [{
      productName: '24/7 Vet Helpline',
      price: '$4.95',
      frequency: 'per month',
      date: '07-06-2025'
    }],
    membershipProduct: {
      productName: 'Lifetime Protection Membership',
      productBenefits: [
        "Access to Lost Pet Recovery Specialists who can quickly launch the process of finding your pet",
        "With 24PetMedAlert®, critical medical and behavioral information will be shared with the shelter or vet the pet is brought to when found (complimentary for 1 year)",
        "Reach veterinary professionals anytime by phone, email or live chat powered by whiskerDocs® (complimentary for 1 year)",
        "Connect with your pet's finder and arrange a quick, safe reunion using DirectConnect.",
        "Save on pet-sitting and dog walking services with a $30 Rover coupon.",
        "Receive a $25 Petco coupon, redeemable for in-store purchases."
      ]
    },
  }

  readMoreHandler() {
    this.setState({
      readMore: !this.state.readMore
    })
  }

  render() {
    const {
      subscriptionProducts,
      membershipProduct,
      annualProduct,
      combinedMedVetProduct,
      winbackProduct,
      renewButtonProps,
      pumpkinWellness,
      autoRenewLinkProps,
      id,
      className,
      style,
      refProp
    } = this.props

    const isMembershipProductAvailable = Object.keys(membershipProduct).length != 0;

    return (
      <Paper
        type={Paper.Types.framed}
        id={id}
        className={cn('ui-existing-membership-plan-card', className)}
        style={style}
        ref={refProp}
      >
        <PaperHeadline>Your Membership</PaperHeadline>

        <PaperContent>
          {isMembershipProductAvailable && (<div className='ui-existing-plan-card'>
            <Text className='ui-existing-plan-card__membership'>
              {membershipProduct.logo ? membershipProduct.logo : <OneTimePurchase />}
              {membershipProduct.productName}
            </Text>

            <Text className='ui-existing-plan-card__label'>
              Included in your plan
            </Text>
            <Divider />
            
            <div>
              <div>
                {membershipProduct.productBenefits.map((item, index) => {
                  if (this.state.readMore || index <= 2) {
                    return (<div className="ui-existing-plan-card__benefits" key={`${membershipProduct.productName.replaceAll(' ', '-')}-Benefits-${index}`}>
                      <Icon type='done' />
                      <span>{item}</span>
                    </div>)
                  }
                })}
              </div>
              {(membershipProduct.productBenefits.length > 3) && (<div className="ui-existing-plan-card__benefits" onClick={() => this.readMoreHandler()}>
                {!this.state.readMore ? <Icon type='expand_more' /> : <Icon type='expand_less' />}
                <span className='ui-existing-plan-card__expand'>{!this.state.readMore ? 'View all benefits' : 'Show less'}</span>
              </div>
              )}
            </div>
          </div>)}

          {!!annualProduct && (
            <div className='ui-existing-plan-card'>
              <Text className='ui-existing-plan-card__membership'>
                {annualProduct.logo ? annualProduct.logo : <OneTimePurchase />}
                {annualProduct.productName}
              </Text>

              <div className='ui-existing-plan-card__price'>
                  <Text className='ui-existing-plan-card__price-value'>
                    {annualProduct?.price.split('.')[0]}
                    {annualProduct?.price.split('.')?.[1] && (<sup>.{annualProduct?.price.split('.')[1]}</sup>)}</Text>
                  <span>
                    {/* <Text className='ui-existing-plan-card__currency'>USD</Text> */}
                    <Text className='ui-existing-plan-card__frequency'>{annualProduct?.frequency}</Text>
                  </span>
              </div>
              <Text className='ui-existing-plan-card__label'>
                Renewal Details
              </Text>
              <Divider />
              <div className='ui-existing-plan-card__renewal-details'>
                {annualProduct?.isExpired && (
                  <>
                    <Text className='ui-existing-plan-card__expired'>Expired: {format(new Date(annualProduct?.expiryDate), 'MMMM do, yyyy')}</Text>
                    <Text className='ui-existing-plan-card__detail'>
                      To renew your subscription, please contact us at 1-866-597-2424
                    </Text>
                  </>
                )}
                  {!annualProduct?.isCancelled && !annualProduct?.isExpired && (
                    <>
                      <Text className='ui-existing-plan-card__next'>Next Payment Due: {format(new Date(annualProduct?.date), 'MMMM do, yyyy')}</Text>
                      <Text className='ui-existing-plan-card__detail'>
                        On {format(new Date(annualProduct?.date), 'MMMM do, yyyy')} you will be charged {annualProduct?.price} for the subscription
                      </Text>
                    {annualProduct.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(annualProduct)}>Click here to turn off auto-renewal</Link>)}
                    </>
                  )}
                  {annualProduct?.isCancelled && !annualProduct?.isExpired && (
                    <>
                      <Text className='ui-existing-plan-card__end'>Coverage Ends: {format(new Date(annualProduct?.expiryDate), 'MMMM do, yyyy')}</Text>
                      <Text className='ui-existing-plan-card__detail'>
                        Auto-renewal has been turned off and your subscription will end on {format(new Date(annualProduct?.expiryDate), 'MMMM do, yyyy')}
                      </Text>
                    {annualProduct.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(annualProduct)}>Click here to turn on auto-renewal</Link>)}
                    </>
                  )}
                {annualProduct.recId === '0' && !annualProduct?.isExpired && (<Text className='ui-existing-plan-card__detail'>Your product registration is in progress and may take up to 24 hours to complete. Once active, you’ll be able to manage your auto-renewal preferences here.</Text>)}
                </div>
            </div>
          )}

          {/* winback Product */}
          {!!winbackProduct && (<div className='ui-existing-plan-card'>
            <div className='ui-existing-plan-card__winback'>
              <div className='ui-existing-plan-card__winback-content'>
                <Text type={Text.Types.headline}>Save money, time and stress!</Text>
                <Text type={Text.Types.body}>
                  Save 25% on these additional coverages. Only {winbackProduct.offerPrice} (reg. $19.95) for 1 full year of access to both 24PetMedAlert® and 24/7 Vet Helpline.
                  Offer ends {winbackProduct.expiryDate}
                </Text>
                <Button
                  size={Button.Sizes.small}
                  color={Button.Colors.tertiary}
                  {...renewButtonProps}
                >
                  Renew Now
                </Button>
              </div>
              <div>
                <img
                  src={PUBLIC_URL + "WinbackImage.png"}
                />
              </div>
            </div>
            <Text className='ui-existing-plan-card__label'>
              Included Coverage
              <Text className='ui-existing-plan-card__detail'>
                1 year included with renewal
              </Text>
            </Text>
            <Divider />
            <div>
              <Text className='ui-existing-plan-card__membership'>
                {ExistingMembershipPlanCard.ProductLogos['vetHelp']}
                24/7 Vet Helpline
              </Text>
              <div className={cn('ui-existing-plan-card__benefits', 'ui-existing-plan-card__winback-product')}>
                <Icon type='done' />
                <span>Reach veterinary professionals anytime by phone, email or live chat powered by whiskerDocs® </span>
              </div>
            </div>
            <div>
              <Text className='ui-existing-plan-card__membership'>
                {<OneTimePurchase />}
                24PetMedAlert®
              </Text>
              <div className={cn('ui-existing-plan-card__benefits', 'ui-existing-plan-card__winback-product')}>
                <Icon type='done' />
                <span>With 24PetMedAlert®, critical medical and behavioral information will be shared with the shelter or vet the pet is brought to when found</span>
              </div>
            </div>
          </div>)}

          {/* subscriptionProducts  */}
          {(!!combinedMedVetProduct && !winbackProduct) && (
            <div className='ui-existing-plan-card'>
              <Text className='ui-existing-plan-card__combined'>
                <span>
                  <OneTimePurchase />
                  24PetMedAlert®
                </span>
                <span>
                  {ExistingMembershipPlanCard.ProductLogos['vetHelp']}
                  24/7 Vet Helpline
                </span>
              </Text>

              <div className='ui-existing-plan-card__price'>
                  <Text className='ui-existing-plan-card__price-value'>
                    {combinedMedVetProduct?.price.split('.')[0]}
                    {combinedMedVetProduct?.price.split('.')?.[1] && (<sup>.{combinedMedVetProduct?.price.split('.')[1]}</sup>)}</Text>
                  <span>
                    {/* <Text className='ui-existing-plan-card__currency'>USD</Text> */}
                    <Text className='ui-existing-plan-card__frequency'>{combinedMedVetProduct?.frequency}</Text>
                  </span>
              </div>
              <Text className='ui-existing-plan-card__label'>
                Renewal Details
                <Text className='ui-existing-plan-card__detail'>
                  1 year included with your Lifetime Protection Membership
                </Text>
              </Text>
              <Divider />
              <div className='ui-existing-plan-card__renewal-details'>
                {combinedMedVetProduct?.isExpired && (
                  <>
                    <Text className='ui-existing-plan-card__expired'>Expired: {format(new Date(combinedMedVetProduct?.expiryDate), 'MMMM do, yyyy')}</Text>
                    <Text className='ui-existing-plan-card__detail'>
                      To renew your subscription, please contact us at 1-866-597-2424
                    </Text>
                  </>
                )}
                {!combinedMedVetProduct?.isCancelled && !combinedMedVetProduct?.isExpired && (
                  <>
                    <Text className='ui-existing-plan-card__next'>Next Payment Due: {format(new Date(combinedMedVetProduct?.date), 'MMMM do, yyyy')}</Text>
                    <Text className='ui-existing-plan-card__detail'>
                      On {format(new Date(combinedMedVetProduct?.date), 'MMMM do, yyyy')} you will be charged {combinedMedVetProduct?.price} for the subscription
                    </Text>
                    {combinedMedVetProduct.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(combinedMedVetProduct)}>Click here to turn off auto-renewal</Link>)}
                  </>
                )}
                {combinedMedVetProduct?.isCancelled && !combinedMedVetProduct?.isExpired && (
                  <>
                    <Text className='ui-existing-plan-card__end'>Coverage Ends: {format(new Date(combinedMedVetProduct?.expiryDate), 'MMMM do, yyyy')}</Text>
                    <Text className='ui-existing-plan-card__detail'>
                      Auto-renewal has been turned off and your subscription will end on {format(new Date(combinedMedVetProduct?.expiryDate), 'MMMM do, yyyy')}
                    </Text>
                    {combinedMedVetProduct.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(combinedMedVetProduct)}>Click here to turn on auto-renewal</Link>)}
                  </>
                )}
                {combinedMedVetProduct.recId === '0' && !combinedMedVetProduct?.isExpired && (<Text className='ui-existing-plan-card__detail'>Your product registration is in progress and may take up to 24 hours to complete. Once active, you’ll be able to manage your auto-renewal preferences here.</Text>)}
              </div>
            </div>
          )}

          {!!pumpkinWellness && (
            <div className='ui-existing-plan-card'>
              <Text className='ui-existing-plan-card__membership'>
                <PWIcon />
                Pumpkin Wellness Club
              </Text>

              <Text className='ui-existing-plan-card__label'>
                Renewal Details
                <Text className='ui-existing-plan-card__detail'>
                  First month free: included with your Lifetime Protection Membership
                </Text>
              </Text>
              <Divider />
              <div className='ui-existing-plan-card__renewal-details'>
                {!pumpkinWellness?.isCancelled && (
                  <>
                    <Text className='ui-existing-plan-card__next'>Next Payment Due: {format(new Date(pumpkinWellness.date), 'MMMM do, yyyy')}</Text>
                    <Text className='ui-existing-plan-card__detail'>
                      On {format(new Date(pumpkinWellness.date), 'MMMM do, yyyy')} you will be charged {pumpkinWellness.price} for your subscription
                    </Text>
                    {pumpkinWellness.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(pumpkinWellness)}>Click here to turn off auto-renewal</Link>)}
                    {/* <Text className='ui-existing-plan-card__cancel'>
                      Call <Link color={Link.Colors.secondary} href={'tel: 1-866-600-2440'}>1-866-600-2440</Link> to cancel your plan. To cancel online,{' '}
                      <Link color={Link.Colors.secondary} target='_blank' href='https://forms.office.com/r/EZ4DrZMHew'>click here</Link> to fill out a cancellation form.
                    </Text> */}
                  </>
                )}
                {pumpkinWellness?.isCancelled && (
                  <>
                    <Text className='ui-existing-plan-card__end'>Coverage Ends: {format(new Date(pumpkinWellness?.expiryDate), 'MMMM do, yyyy')}</Text>
                    <Text className='ui-existing-plan-card__detail'>
                      Your subscription has been cancelled and will end on {format(new Date(pumpkinWellness.date), 'MMMM do, yyyy')}
                    </Text>
                    <Text className='ui-existing-plan-card__cancel'>
                      Call <Link color={Link.Colors.secondary} href={'tel: 1-866-600-2440'}>1-866-600-2440</Link> to update your subscription preferences.
                    </Text>
                  </>
                )}
                {pumpkinWellness.recId === '0' && (<Text className='ui-existing-plan-card__detail'>Your product registration is in progress and may take up to 24 hours to complete. Once active, you’ll be able to manage your auto-renewal preferences here.</Text>)}
              </div>
            </div>
          )}

          {subscriptionProducts.map((item, index) => {
            return (
              <div className='ui-existing-plan-card' key={`${item.productName?.replaceAll(' ', '-')}-${index}`}>
                <Text className='ui-existing-plan-card__membership'>
                  {item.logo ? ExistingMembershipPlanCard.ProductLogos[item.logo] : <OneTimePurchase />}
                  {item.productName}
                </Text>

                <div className='ui-existing-plan-card__price'>
                  <Text className='ui-existing-plan-card__price-value'>
                    {item?.price.split('.')[0]}
                    {item?.price.split('.')?.[1] && (<sup>.{item?.price.split('.')[1]}</sup>)}</Text>
                  <span>
                    {/* <Text className='ui-existing-plan-card__currency'>USD</Text> */}
                    <Text className='ui-existing-plan-card__frequency'>{item.frequency}</Text>
                  </span>
                </div>
                <Text className='ui-existing-plan-card__label'>
                  Renewal Details
                </Text>
                <Divider />
                <div className='ui-existing-plan-card__renewal-details'>
                  {!item?.isCancelled && (
                    <>
                      <Text className='ui-existing-plan-card__next'>Next Payment Due: {format(new Date(item?.date), 'MMMM do, yyyy')}</Text>
                      <Text className='ui-existing-plan-card__detail'>
                        On {format(new Date(item?.date), 'MMMM do, yyyy')} you will be charged {item?.price} for the subscription
                      </Text>
                      {item.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(item)}>Click here to turn off auto-renewal</Link>)}
                    </>
                  )}
                  {item?.isCancelled && (
                    <>
                      <Text className='ui-existing-plan-card__end'>Coverage Ends: {format(new Date(item?.expiryDate), 'MMMM do, yyyy')}</Text>
                      <Text className='ui-existing-plan-card__detail'>
                        Auto-renewal has been turned off and your subscription will end on {format(new Date(item?.expiryDate), 'MMMM do, yyyy')}
                      </Text>
                      {item.recId !== '0' && (<Link color={Link.Colors.secondary} onClick={() => autoRenewLinkProps.onClick(item)}>Click here to turn on auto-renewal</Link>)}
                    </>
                  )}
                  {item.recId === '0' && (<Text className='ui-existing-plan-card__detail'>Your product registration is in progress and may take up to 24 hours to complete. Once active, you’ll be able to manage your auto-renewal preferences here.</Text>)}
                </div>
              </div>
            )
          })}
        </PaperContent>
      </Paper>
    )
  }
}
